// @flow
import { decorate, observable, action } from 'mobx';
import type { Skill, UserSkill } from 'gwu';
import Api from '../../api';
import userStore from '../user/UserStore';

class SkillStore {
  skills: Array<Skill> = [];
  isFetchingSkills: boolean = true;
  userSkills: Array<UserSkill> = [];
  isFetchingUserSkills: boolean = true;

  async fetchSkills() {
    if (this.skills.length > 0) {
      return;
    }

    try {
      this.isFetchingSkills = true;
      const { data } = await Api.getSkills();
      if (data !== undefined) {
        this.skills = data;
      }
      this.isFetchingSkills = false;
    }
    catch (e) {
      this.isFetchingSkills = false;
    }
  }

  getUsername(): string {
    return (userStore.user !== null) ? userStore.user.username : '';
  }

  async fetchUserSkills() {
    if (this.skills.length > 0) {
      return;
    }

    try {
      this.isFetchingUserSkills = true;
      const { data } = await Api.getUserSkills(this.getUsername());
      if (data !== undefined) {
        this.userSkills = data;
      }
      this.isFetchingUserSkills = false;
    }
    catch (e) {
      this.isFetchingUserSkills = false;
    }
  }

  async selectSkill(skillId: number) {
    try {
      // TODO check for success
      const { data } = await Api.addSkillForUser(this.getUsername(), skillId);
      const userSkill: UserSkill = data;
      this.userSkills.push(userSkill);
    }
    catch (e) {
      // TODO handle exception
    }
  }

  async deselectSkill(skillId: number) {
    try {
      // TODO check for success
      await Api.removeSkillForUser(this.getUsername(), skillId);
      this.userSkills = this.userSkills.filter(us => us.skillId !== skillId);
    }
    catch (e) {
      // TODO handle exception
    }
  }

  async rateSkill(skillId: number, rating: number) {
    try {
      // TODO check for success
      await Api.rateSkillForUser(this.getUsername(), skillId, rating);
      const existingUserSkill: UserSkill | void = this.userSkills.find(us => us.skillId === skillId);
      if (existingUserSkill) { // atm we assume skills are selected first (separately)
        existingUserSkill.rating = rating;
      }
    }
    catch (e) {
      // TODO handle exception
    }
  }
}

decorate(SkillStore, {
  skills: observable,
  isFetchingSkills: observable,
  userSkills: observable,
  isFetchingUserSkills: observable,
  fetchSkills: action,
  fetchUserSkills: action,
  selectSkill: action,
  deselectSkill: action,
  rateSkill: action
});

export default new SkillStore();



// WEBPACK FOOTER //
// ./src/modules/skill/SkillStore.js